export default {
  booking_request: require('./booking_request').default,
  booking_details: require('./booking_details').default,
  d13n: require('./d13n').default,
  tour_availability: require('./tour_availability').default,
  message: require('./message').default,
  integration: require('./integration').default,
  pricing: require('./pricing').default,
};
